import { PageProps } from '../../../src/components/Page';
import AdditionalScripts from './AdditionalScripts';

export default function RootScripts({ pageProps }: { pageProps?: PageProps }) {
  return (
    <>
      <AdditionalScripts
        pageProps={{
          embeddedWidget: pageProps?.embeddedWidget,
          disablePushPrompt: pageProps?.disablePushPrompt ?? true,
        }}
      />
    </>
  );
}
